import { render, staticRenderFns } from "./IdentityCheck.vue?vue&type=template&id=49617b0a&scoped=true&"
import script from "./IdentityCheck.vue?vue&type=script&lang=js&"
export * from "./IdentityCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49617b0a",
  null
  
)

export default component.exports